import { defineStore } from "pinia";
import { showSuccess, showError } from "src/utils/notify";

export const useMoreStore = defineStore("morestore", {
  state: () => ({
    friendRequests: [],
    loadFriendRequests: false,
    teamRequests: [],
    loadTeamRequests: false,
    loyaltyCards: [],
    loadLoyaltyCards: false,
  }),
  getters: {
    getFriendRequests: (state) => {
      return state.friendRequests;
    },
    getTeamRequests: (state) => {
      return state.teamRequests;
    },
  },
  actions: {
    async fetchFriendRequests() {
      try {
        let data = await this.$request.get(
          this.apiEndpoints.GET_FRIEND_REQUESTS
        );
        if (data.data && data.data.status) {
          this.friendRequests = data.data.items;
        } else {
          this.friendRequests = [];
        }
        this.loadFriendRequests = true;
      } catch (error) {}
    },
    async acceptFriendRequest(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.ACCEPT_FRIEND_REQUEST(id)
        );
        if (data.data && data.data.status) {
          this.removeFriendRequest(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error)
        showError("Something went wrong, please try again later");
      }
    },
    async denyFriendRequest(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.DENY_FRIEND_REQUEST(id)
        );
        if (data.data && data.data.status) {
          this.removeFriendRequest(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error)
        showError("Something went wrong, please try again later");
      }
    },
    async cancelFriendRequest(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.CANCEL_FRIEND_REQUEST(id)
        );
        if (data.data && data.data.status) {
          this.removeFriendRequest(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error);
        showError("Something went wrong, please try again later");
      }
    },
    removeFriendRequest(id) {
      this.friendRequests = this.friendRequests.filter((x) => x.id != id);
    },
    async fetchTeamRequests() {
      try {
        let data = await this.$request.get(this.apiEndpoints.GET_TEAM_REQUESTS);
        if (data.data && data.data.status) {
          this.teamRequests = data.data.items;
        } else {
          this.teamRequests = [];
        }
        this.loadTeamRequests = true;
      } catch (error) {}
    },
    async fetchLoyaltyCards() {
      try {
        let data = await this.$request.get(this.apiEndpoints.GET_LOYALTY_CARDS);
        if (data.data && data.data.status) {
          this.loyaltyCards = data.data.items;
        } else {
          this.loyaltyCards = [];
        }
        this.loadLoyaltyCards = true;
      } catch (error) {}
    },
    async acceptTeamRequest(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.ACCEPT_TEAM_REQUEST(id)
        );
        if (data.data && data.data.status) {
          this.removeTeamRequest(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error);
        showError("Something went wrong, please try again later");
      }
    },
    async denyTeamRequest(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.DENY_TEAM_REQUEST(id)
        );
        if (data.data && data.data.status) {
          this.removeTeamRequest(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error);
        showError("Something went wrong, please try again later");
      }
    },
    async cancelTeamRequest(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.CANCEL_TEAM_REQUEST(id)
        );
        if (data.data && data.data.status) {
          this.removeTeamRequest(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error);
        showError("Something went wrong, please try again later");
      }
    },
    removeTeamRequest(id) {
      this.teamRequests = this.teamRequests.filter((x) => x.id != id);
    },
    async deleteLoyaltyCard(id) {
      try {
        let data = await this.$request.post(
          this.apiEndpoints.REMOVE_LOYALTY_CARD(id)
        );
        if (data.data && data.data.status) {
          this.removeLoyaltyCard(id);
          showSuccess(data.data.message);
        } else {
          if (data.data.message) showError(data.data.message);
        }
      } catch (error) {
        // console.log(error);
        showError("Something went wrong, please try again later");
      }
    },
    removeLoyaltyCard(id) {
      this.loyaltyCards = this.loyaltyCards.filter((x) => x.id != id);
    },
  },
});
